<ng-template #template>
  <div class="modal-header header-style">
    <h3 class="modal-title pull-left">Individual Provider Request</h3>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true"><img class="resize" src="assets/img/icons/icn-remove-dark.svg" alt="close"></span>
    </button>
  </div>
  <div class="modal-body bod-text">
    <div class="container-fluid">
      <div class="row mb-4 info-text">
        Please make your request as an individual
        provider below and include any specifics in your request details.
        All fields are required unless marked optional.
      </div>
      <div class="row mb-2 option-text">
        What type of update are you requesting?
      </div>
      <!-- radio-selection section -->
      <div class="selection-panel">
        <ul class="list-group list-group-radio">
          <li class="list-group-item">
            <label class="radio-label">
              <input type="radio"
                  class="mr-1"
                  name="radio2"
                  [checked]="(num == 1)"
                  aria-label="New Provider"
                  aria-labeledby="Radio_Buttons"
                  (click)="showForm('NEW')">
              <span>New Provider</span>
              <div class="subtle-text">I need to add a new individual provider to United Concordia.</div>
              <span class="checkmark"></span>
            </label>
          </li>
          <li class="list-group-item">
            <label class="radio-label">
              <input type="radio"
                  class="mr-1"
                  name="radio2"
                  [checked]="(num == 2)"
                  aria-label="Maintenance"
                  aria-labeledby="Radio_Buttons"
                  (click)="showForm('MAINTENANCE')">
              <span>Maintenance</span>
              <div class="subtle-text">I need to update existing information for an individual provider.</div>
              <span class="checkmark"></span>
            </label>
          </li>
          <li class="list-group-item">
            <label class="radio-label">
                <input type="radio"
                    class="mr-1"
                    name="radio2"
                    [checked]="(num == 3)"
                    aria-label="Resign Participation"
                    aria-labeledby="Radio_Buttons"
                    (click)="showForm('RESIGNATION')">
                <span>Resign Participation</span>
                <div class="subtle-text">I need to inform you about an individual provider's resignation.</div>
                <span class="checkmark"></span>
              </label>
          </li>
        </ul>
      </div>
      <!-- end of radio selection section -->
    </div>
  </div>
  <div *ngIf="blank">
    <app-blank-component></app-blank-component>
  </div>
  <div *ngIf="new">
    <app-new></app-new>
  </div>
  <div *ngIf="maintenance">
    <app-maintenance></app-maintenance>
  </div>
  <div *ngIf="resignation">
    <app-resignation></app-resignation>
  </div>
</ng-template>
